export default "__VITE_ASSET__JoqxNOYi__"